import { observable, action } from "mobx"
import * as API from "../../app/api"
import { firebase, INVOICES_ENDPOINT } from "../../app/constants"

class InvoiceStore {
  @observable error = null
  @observable loading = false
  @observable invoices = null

  @action.bound
  loadInvoices(forceReload = false) {
    if (this.invoices && !forceReload) return
    this.loading = true
    this.invoices = null
    firebase
      .auth()
      .currentUser.getToken(true)
      .then(idToken => API.get(`${INVOICES_ENDPOINT}?idToken=${idToken}`))
      .then(res => res.json())
      .then(
        action(invoices => {
          this.invoices = invoices.data
        })
      )
      .catch(
        action(error => {
          this.error = null
        })
      )
      .then(
        action(() => {
          this.loading = false
        })
      )
  }
}

export default new InvoiceStore()



// WEBPACK FOOTER //
// ./src/account/invoices/invoice-store.js